import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

interface SortOption {
  sortBy: number;
  sortDirection: number;
}

@Component({
  selector: 'ops-sort-menu-button',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './ops-sort-menu-button.component.html',
  styleUrl: './ops-sort-menu-button.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class OpsSortMenuButton {
  @Input() sort?: SortOption;
  @Output() sortChanged: EventEmitter<SortOption> =
    new EventEmitter<SortOption>();

  isExpanded = 0;
  activeOption?: number = this.sort?.sortBy || 0;
  sortDirection: number = this.sort?.sortDirection || 0;
  closeTimeout: any = null;
  mouseLeft = false;
  mouseEnter = false;

  sortOptions = [
    {
      id: 0,
      name: 'Project Code',
    },
    {
      id: 1,
      name: 'Approval Date',
    },
    {
      id: 2,
      name: 'Client',
    },
    {
      id: 5,
      name: 'Project Status',
    },
  ];

  // ,
  // {
  //   id:3,
  //   name: 'Status'
  // },{
  //   id:4,
  //   name: 'Financial Year'
  // }

  constructor(private elementRef: ElementRef) {
    this.isExpanded = 0;
  }

  toggleSort() {
    // console.log('TOGGLE');
    if (this.isExpanded === 1) {
      this.isExpanded = 2;
    } else if (this.isExpanded === 2) {
      this.isExpanded = 1;
    } else if (this.isExpanded === 0) {
      this.isExpanded = 1;
    }
  }

  sortOptionClass(sortItem: any) {
    const classList = ['sort-option-item'];
    if (sortItem.id === this.activeOption) {
      classList.push('active');
      if (this.sortDirection) {
        classList.push('asc');
      }
      if (!this.sortDirection) {
        classList.push('desc');
      }
      return classList.join(' ');
    }
    return 'sort-option-item';
  }

  toggleSortOption(optionId: number) {
    if (this.activeOption != optionId) {
      this.activeOption = optionId;
      this.sortDirection = 0;
    } else if (this.activeOption == optionId) {
      if (this.sortDirection == 0) {
        this.sortDirection = 1;
      } else {
        this.activeOption = null;
        this.sortDirection = 0;
      }
    }

    this.sortChanged.emit({
      sortBy: this.activeOption === null ? -1 : this.activeOption,
      sortDirection: this.sortDirection,
    });
  }

  startCloseTimeout(waitingTime?: number) {
    clearTimeout(this.closeTimeout);

    const wTime = waitingTime || 1000;

    if (this.isExpanded) {
      this.closeTimeout = setTimeout(() => {
        this.isExpanded = 2;
      }, wTime);
    }
  }

  // Cancel close timeout if hovered
  @HostListener('mouseenter')
  onMouseEnter() {
    this.mouseLeft = false;
    this.mouseEnter = true;
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }
  }

  // Handle blur and close dropdown after a timeout
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      clearTimeout(this.closeTimeout);
      if (this.isExpanded === 1) {
        this.isExpanded = 2;
      }
    }
  }

  // Reset close timeout if user hovers back
  @HostListener('mouseleave')
  onMouseLeave() {
    this.mouseLeft = true;
    this.startCloseTimeout();
  }
}
